import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actionCreators from '../../../actionCreators/handoff';
import RowSettings from '../../../components/handoff/layout/RowSettings';
import onlyIf from '../../../hocs/onlyIf';
import { getIsRowOverlayOn, getRowSettings, getRowsEnabled, } from '../../../selectors/layoutOverlay';
function mapStateToProps(state) {
    try {
        // TODO remove when using easel api v2
        return __assign(__assign({}, getRowSettings(state)), { isOverlayOn: getIsRowOverlayOn(state), isOverlayEnabled: getRowsEnabled(state) });
    }
    catch (e) {
        return {
            isOverlayEnabled: false,
        };
    }
}
function mapDispatchToProps(dispatch) {
    return {
        toggleOverlay: function () {
            dispatch(actionCreators.toggleRowOverlay());
        },
    };
}
var isOverlayEnabled = function (props) { return props.isOverlayEnabled; };
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(isOverlayEnabled))(RowSettings);
